// src/app/features/fincenReports/CreateFincenReport.tsx
import { DashboardContainerHeader } from 'app/layout/dashboardLayout/BoxLayout';
import { useCreateFincenReportMutation } from 'app/services/fincenReports';
import { SaveIcon } from 'assets/icons';
import Button from 'Components/Buttons/Button';
import { successToast, errorToast } from 'Components/Notifications';
import { useAuth } from 'utils/AuthProvider';
import FincenReportForm from './FincenReportForm';
import { useNavigate } from 'react-router-dom';
import { prepareHeaders } from 'utils'; // Assuming this adds authorization token

export default function CreateFincenReport() {
  const [CreateTrigger, { isLoading }] = useCreateFincenReportMutation();
  const { user } = useAuth();
  const navigate = useNavigate();

  // Create rep and initiate the payment
  const handleCreateAndPay = async (data: any) => {
    try {
      // Set the price based on the type (individual or business)
      let report_price = 169.99; // Default for business
      if (data.type === 'individual') {
        report_price = 119.99; // Price for individual
      }

      // Add the price to the data object
      const requestData = {
        ...data,
        report_price,
      };

      const res = await CreateTrigger(requestData).unwrap();
      successToast('FinCEN report submitted');

      const requestId = res.id; // Assuming the response contains the tax extension request ID

      // Prepare headers with authorization token
      const headers = await prepareHeaders(new Headers());
      headers.append('Content-Type', 'application/json');

      // Call the payment API
      const paymentResponse = await fetch(
        `${process.env.REACT_APP_API_URL}/fincen_reports_requests/${requestId}/pay`,
        {
          method: 'POST',
          headers, // Use the prepared headers with authorization
        },
      );

      const paymentData = await paymentResponse.json();

      if (paymentData.checkout_url) {
        // Redirect to Stripe checkout URL
        window.location.href = paymentData.checkout_url;
      } else {
        errorToast('Payment initiation failed');
      }
    } catch (error) {
      errorToast('Failed to create FinCEN report');
    }
  };

  return (
    <>
      <DashboardContainerHeader title={'FinCEN Report'}>
        <Button
          isLoading={isLoading}
          form="fincen-report-form"
          className="max-w-min"
        >
          <SaveIcon className="w-4 h-4" />
          Create
        </Button>
      </DashboardContainerHeader>
      <FincenReportForm
        value={{
          submittedbyfirstname: user?.given_name,
          submittedbylastname: user?.family_name,
          submittedbyemail: user?.email,
          ssn: user?.ssn,
          phoneNumber: user?.phone_number,
          reachPhoneNumber: user?.phone_number,
          mailingaddress: user?.address,
          mailingcity: user?.city,
          state: user?.state,
          zip: user?.zipcode,
        }}
        onChange={(data) => handleCreateAndPay(data)}
        isLoading={isLoading}
      />
    </>
  );
}
